












































import { PaginationSyncDTO, ResultPagDTO } from '@/interfaces/base-dto';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '../base-component.vue';
import ListMessages from '../UI/list-messages.vue';
import PermissionAuth from '../UI/permission-auth.vue';
import * as service from '@/services/async-process';
import { ProcExecFiltrosParmDTO } from '@/interfaces/async-process';
import { BehaviorSubject } from 'rxjs';

@Component({
  components: {
    ListMessages,
    PermissionAuth
  }
})
export default class AsyncProcessTable extends BaseComponent {
  @Prop()
  type: string;

  @Prop()
  versionUpdate: number;

  headers: any = [
    { text: '', value: 'status', sortable: false, width: '50px' },
    { text: 'Parametros', value: 'detalhes', sortable: false },
    { text: 'Solicitado em', value: 'dataCriacaoFmt', sortable: false },
    { text: 'Situação', value: 'status', sortable: false },
    { text: 'Data', value: 'dataStatusFmt', sortable: false },
    { text: '', value: 'detalhes', sortable: false }
  ];

  pagination: PaginationSyncDTO = new PaginationSyncDTO();
  pagina: ResultPagDTO<any> = new ResultPagDTO();
  error: boolean = false;
  loading: boolean = false;
  items: any[] = [];

  mounted() {
    this.buildBs();
    this.load(true);
  }

  loadTimeout = null;

  buildLoadTimeout(ms) {
    clearTimeout(this.loadTimeout);
    this.loadTimeout = setTimeout(() => {
      this.load(true);
    }, ms);
  }

  beforeDestroy() {
    clearTimeout(this.loadTimeout);
  }

  bs$: BehaviorSubject<any> = new BehaviorSubject(null);
  quiet = false;
  buildBs() {
    this.bs$ = this.buildBehaviorSubject(
      (f) => {
        return service.listAsyncProcess(f);
      },
      () => {
        if (!this.quiet) {
          this.loading = true;
        }
      },
      300,
      (res) => {
        this.items = res.content;
        this.loading = false;
        this.pagina = res;
        PaginationSyncDTO.update(this.pagination, res);
        let pending = this.items.find((i) => !i.finalizado) != null;
        this.buildLoadTimeout(pending ? 3000 : 10000);
      },
      (error) => {
        this.loading = false;
        this.error = true;
        this.buildBs();
        this.buildLoadTimeout(10000);
      }
    );
  }

  load(quiet = false) {
    if (this.type == null) {
      return;
    }
    this.quiet = quiet;
    let parms = new ProcExecFiltrosParmDTO();
    parms.tipo = this.type;
    parms.update(this.pagination);
    this.bs$.next(parms);
  }

  download(item) {
    window.open(item.resultado, '_blank');
  }

  @Watch('versionUpdate')
  onVersionUpdateChange() {
    this.load(true);
  }

  @Watch('pagination.page')
  @Watch('pagination.rowsPerPage')
  @Watch('pagination.sortBy')
  @Watch('pagination.descending')
  onChangePagination() {
    this.load();
  }
}
